import { createContext } from 'react';

const QuizCongratulations = createContext({
  progressReport : null,
});

export default QuizCongratulations;
